import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function timeRangeValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const startTime = group.get('time_start')?.value;
    const endTime = group.get('time_end')?.value;
    const startDate = group.get('date_start')?.value;
    const endDate = group.get('date_end')?.value;

    // Se è un evento tutto il giorno, non validare l'orario
    if (group.get('isallday')?.value == 1 || group.get('isallday')?.value == true) {
      return null;
    }

    // Se non ci sono orari, errore (tranne se è tutto il giorno)
    if (!startTime || !endTime) {
      return { required: true };
    }

    // Se le date sono diverse, l'evento si estende su più giorni
    // In questo caso l'orario non ha senso, quindi non validare
    if (startDate && endDate && startDate !== endDate) {
      return null;
    }

    // Se le date sono uguali, valida che l'orario di fine sia maggiore di quello di inizio
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const [endHour, endMinute] = endTime.split(':').map(Number);

    const start = startHour * 60 + startMinute;
    const end = endHour * 60 + endMinute;

    if (start >= end) {
      return { timeRangeInvalid: true };
    }

    return null;
  };
}
